module.exports = __webpack_public_path__ + "static/media/Mysti-here-you-go.e93f6488.png";